import { render, staticRenderFns } from "./newProductPandect.vue?vue&type=template&id=5f189f10"
import script from "./newProductPandect.vue?vue&type=script&lang=js"
export * from "./newProductPandect.vue?vue&type=script&lang=js"
import style0 from "./newProductPandect.vue?vue&type=style&index=0&id=5f189f10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports